/* ──────────────────────────────────────────────────────────
   stacked-cards.js  –  Stacked cards scroll animation
   ────────────────────────────────────────────────────────── */

import { ScrollTrigger } from "./gsap-setup.js";

document.addEventListener("DOMContentLoaded", () => {
    // Find all stacked card sections
    const sections = document.querySelectorAll('.stacked-cards-section[data-pin="gsap"]');

    sections.forEach((section) => {
        const cards = section.querySelectorAll('.stacked-card');

        if (cards.length === 0) return;

        cards.forEach((card, index) => {
            // Don't pin the last card
            if (index === cards.length - 1) return;

            ScrollTrigger.create({
                trigger: card,
                start: "top top",
                pin: true,
                pinSpacing: false,
                scrub: 1,
                invalidateOnRefresh: true,
                // markers: true, // Uncomment for debugging
            });
        });
    });
});
